/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentExpiredStatusFault } from "./PaymentExpiredStatusFault";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum FaultCodeCategoryEnum {
  "PAYMENT_EXPIRED" = "PAYMENT_EXPIRED"
}

/**
 * A PaymentProblemJson-like type specific for the GetPayment and ActivatePayment operations.
 * Possible values of `detail_v2` are limited to faults pertaining to Nodo errors related to payment status conflicts.
 */

// required attributes
const PaymentExpiredStatusFaultPaymentProblemJsonR = t.interface({
  faultCodeCategory: enumType<FaultCodeCategoryEnum>(
    FaultCodeCategoryEnum,
    "faultCodeCategory"
  ),

  faultCodeDetail: PaymentExpiredStatusFault
});

// optional attributes
const PaymentExpiredStatusFaultPaymentProblemJsonO = t.partial({
  title: t.string
});

export const PaymentExpiredStatusFaultPaymentProblemJson = t.intersection(
  [
    PaymentExpiredStatusFaultPaymentProblemJsonR,
    PaymentExpiredStatusFaultPaymentProblemJsonO
  ],
  "PaymentExpiredStatusFaultPaymentProblemJson"
);

export type PaymentExpiredStatusFaultPaymentProblemJson = t.TypeOf<
  typeof PaymentExpiredStatusFaultPaymentProblemJson
>;
